import {LOOKUP_ENUM} from "../../dictionary/core/lookup.enum";
export const INVENTORY_STATUS_ENUM = LOOKUP_ENUM.INVENTORY_STATUS;
